import { Skeleton } from '@/components/ui/skeleton';
import { useMe } from '@/hooks/use-auth';
import { type ReactNode, Suspense } from 'react';
import { DemoModeBanner } from './DemoModeBanner';
import { EmailVerificationBanner } from './EmailVerificationBanner';
import { Sidebar } from './Sidebar';
import { TenantSwitchOverlay } from './TenantSwitchOverlay';
import { Topbar } from './Topbar';

interface AppShellProps {
  children: ReactNode;
}

function PageFallback() {
  return (
    <div className="space-y-4">
      <Skeleton className="h-10 w-1/3" />
      <Skeleton className="h-4 w-2/3" />
      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
        <Skeleton className="h-28" />
        <Skeleton className="h-28" />
        <Skeleton className="h-28" />
        <Skeleton className="h-28" />
      </div>
      <Skeleton className="h-64 w-full" />
    </div>
  );
}

export function AppShell({ children }: AppShellProps) {
  const me = useMe();
  return (
    <div className="flex h-screen bg-background">
      <Sidebar />
      <div className="flex flex-1 flex-col overflow-hidden">
        <DemoModeBanner />
        <EmailVerificationBanner />
        <Topbar />
        <main className="flex-1 overflow-y-auto p-6">
          <Suspense fallback={<PageFallback />}>{children}</Suspense>
        </main>
      </div>
      <TenantSwitchOverlay currentTenantId={me.data?.currentTenant?.tenantId} />
    </div>
  );
}
